<template>
  <div>
    <loader v-if="is.loading" />
    <template v-else>
      <div class="mb-5" v-if="locationTasks.length > 0">
        <h4>Offene Aufgaben</h4>

        <div class="status-group mb-2">
          <template v-if="locationTasksLoaded && locationTasks.length > 0">
            <task-item v-for="(task) in locationTasks"
                       :key="task.id"
                       :task="task"
                       :order="entity"
                       @task-resolved="onTaskResolved" />
          </template>
          <template v-else>
            <status-badge icon="b-check-circle-fill" variant="success" title="Adressierung der Bestellung komplett" position="single">
              Adressierung der Bestellung komplett
            </status-badge>
          </template>
        </div>
      </div>
      <order-configuration :configuration="entity.configuration" :order="entity" :order-data="orderData" @location-selected="onLocationSelected"
                           @delivery-address-selected="onDeliveryAddressSelected" />
    </template>
  </div>
</template>

<script>
import Loader from '@/components/Loader';
import MixinEntityBase from '@/components/mixins/EntityBase';
import OrderConfiguration from '@/components/order/orderly/OrderConfiguration';
import StatusBadge from '@/components/order/orderly/StatusBadge';
import TaskItem from '@/components/order/orderly/TaskItem';

export default {
  name: 'Orders.Detail',
  mixins: [MixinEntityBase],
  components: {
    OrderConfiguration,
    Loader,
    TaskItem,
    StatusBadge
  },
  data() {
    return {
      orderData: null,
      orderDataLoaded: false,
      allOrderlyTasks: [], // Store all tasks, not just incomplete ones
      locationTasksLoaded: false
    }
  },
  computed: {
    is() {
      return this.$store.getters[`${this.eParent.key}/is`]
    },
    entity() {
      return this.$store.getters[`${this.eParent.key}/getEntityUnwrapped`](this.eParent.id) || {}
    },
    orderlyTasks() {
      // Filter incomplete tasks reactively
      return this.allOrderlyTasks.filter(task => task.isCompleted === false)
    },
    locationTasks() {
      return this.orderlyTasks.filter(task => task.section === 'Location')
    }
  },
  mounted() {
    this.$store.dispatch('orderparsedata/getByOrderId', { orderId: this.eParent.id })
      .then(response => {
        this.orderData = response.result
        this.orderDataLoaded = true
      })
      .then(() => {
        this.$store.dispatch('orderlytasks/getByOrderParseDataId', { orderParseDataId: this.orderData.id })
          .then(response => {
            this.allOrderlyTasks = response.result // Store all tasks
            this.locationTasksLoaded = true
          })
      })
      .catch(error => {
        console.error(error)
      })
  },
  methods: {
    onLocationSelected(location) {
      const locationId = location.id

      this.$store.dispatch('locations/getEntity', locationId)
        .then(locationEntity => {
          const configuration = Object.assign({}, this.entity.configuration)
          configuration.location = locationEntity.value
          configuration.deliveryAddress = null

          this.$store.dispatch('orders/updateOrderConfiguration', {
            orderId: this.entity.orderId,
            data: configuration
          })
            .then(() => {
              this.$store.dispatch(`${this.eParent.key}/getEntity`, this.entity.orderId)
            })
        })

      // Show success message
      this.$bvToast.toast(`Standort "${location.name}" wurde ausgewählt`, {
        title: 'Standort ausgewählt',
        variant: 'success',
        solid: true
      })
    },
    onDeliveryAddressSelected(address) {
      const configuration = Object.assign({}, this.entity.configuration)
      configuration.deliveryAddress = address

      this.$store.dispatch('orders/updateOrderConfiguration', {
        orderId: this.entity.orderId,
        data: configuration
      })
        .then(() => {
          this.$store.dispatch(`${this.eParent.key}/getEntity`, this.entity.orderId)
        })

      // Show success message
      this.$bvToast.toast('Lieferadresse wurde ausgewählt', {
        title: 'Lieferadresse ausgewählt',
        variant: 'success',
        solid: true
      })
    },
    onTaskResolved(taskId) {
      this.$store.dispatch('orderlytasks/getByOrderParseDataId', { orderParseDataId: this.orderData.id })
        .then(response => {
          this.allOrderlyTasks = response.result // Store all tasks - filtering is now reactive
          this.locationTasksLoaded = true
        })
    }
  }
}
</script>
